import { useState } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';

export default () => {
  const [postcodes, setPostcodes] = useState([]);
  const history = useHistory();

  const getPostcode = async (postcode) => {
    try {
      const response = await pharmacy.get(`/addresses/postcode/${postcode}`);
      setPostcodes(response.data);
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  return [postcodes, getPostcode];
};
